const { GET_HOME_CONTENT } = require("redux/reseller-constants");

const initialState = { 
    resellerHomeData:[],
}

const reducer = (state = initialState,  action) => {
const {
  type,
  payload
} = action;

switch (type) {
  case GET_HOME_CONTENT: {
    
    return {
      ...state,
      resellerHomeData: payload,
    }
  }

  default:
    return state;
  }
}

export default reducer;